import React from 'react';
import { Menu, X } from 'lucide-react';
import Logo from './Logo';

const Navbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  return (
    <nav className="fixed top-0 left-0 right-0 bg-white border-b border-gray-100 py-4 px-6 z-50">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Logo className="h-8 w-auto" />
        </div>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center gap-8">
          <a href="#features" className="text-[#2E6173] hover:text-[#103541] transition-colors">
            Funcionalidades
          </a>
          <a href="#benefits" className="text-[#2E6173] hover:text-[#103541] transition-colors">
            Benefícios
          </a>
          <a href="#faq" className="text-[#2E6173] hover:text-[#103541] transition-colors">
            FAQ
          </a>
          <button 
            className="relative bg-[#7AEA53] text-white px-6 py-2.5 rounded-lg font-medium
              transition-all duration-200 ease-out
              hover:bg-[#6DD142] hover:shadow-lg hover:-translate-y-0.5
              focus:outline-none focus:ring-2 focus:ring-[#7AEA53] focus:ring-offset-2
              active:bg-[#5CC031] active:translate-y-0 active:shadow-none
              disabled:bg-gray-200 disabled:text-gray-400 disabled:cursor-not-allowed disabled:transform-none"
            onClick={() => document.getElementById('quiz')?.scrollIntoView({ behavior: 'smooth' })}
          >
            Fazer Diagnóstico
          </button>
        </div>

        {/* Mobile Menu Button */}
        <button 
          className="md:hidden text-[#103541]"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="absolute top-full left-0 right-0 bg-white border-b border-gray-100 py-4 px-6 md:hidden">
            <div className="flex flex-col gap-4">
              <a 
                href="#features" 
                className="text-[#2E6173] hover:text-[#103541] transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Funcionalidades
              </a>
              <a 
                href="#benefits" 
                className="text-[#2E6173] hover:text-[#103541] transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Benefícios
              </a>
              <a 
                href="#faq" 
                className="text-[#2E6173] hover:text-[#103541] transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                FAQ
              </a>
              <button 
                className="bg-[#7AEA53] text-white px-6 py-2 rounded-lg hover:bg-[#6DD142] transition-all w-full"
                onClick={() => {
                  document.getElementById('quiz')?.scrollIntoView({ behavior: 'smooth' });
                  setIsMenuOpen(false);
                }}
              >
                Fazer Diagnóstico
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;